module.exports = __webpack_public_path__ + "static/media/colicoli22.e7acd782.webp";